import { ContractualMonth } from "@shared/models";

export const CONTRACTUAL_MONTHS: ContractualMonth[] = [
  {
    monthLong: "January",
    monthShort: "JAN",
    start: { month: "01", day: "01" },
    end: { month: "01", day: "30" },
    asInt: "01",
  },
  {
    monthLong: "February",
    monthShort: "FEB",
    start: { month: "01", day: "31" },
    end: { month: "03", day: "01" },
    asInt: "02",
  },
  {
    monthLong: "March",
    monthShort: "MAR",
    start: { month: "03", day: "02" },
    end: { month: "03", day: "31" },
    asInt: "03",
  },
  {
    monthLong: "April",
    monthShort: "APR",
    start: { month: "04", day: "01" },
    end: { month: "05", day: "01" },
    asInt: "04",
  },
  {
    monthLong: "May",
    monthShort: "MAY",
    start: { month: "05", day: "02" },
    end: { month: "06", day: "01" },
    asInt: "05",
  },
  {
    monthLong: "June",
    monthShort: "JUN",
    start: { month: "06", day: "02" },
    end: { month: "07", day: "01" },
    asInt: "06",
  },
  {
    monthLong: "July",
    monthShort: "JUL",
    start: { month: "07", day: "02" },
    end: { month: "07", day: "31" },
    asInt: "07",
  },
  {
    monthLong: "August",
    monthShort: "AUG",
    start: { month: "08", day: "01" },
    end: { month: "08", day: "30" },
    asInt: "08",
  },
  {
    monthLong: "September",
    monthShort: "SEP",
    start: { month: "08", day: "31" },
    end: { month: "09", day: "30" },
    asInt: "09",
  },
  {
    monthLong: "October",
    monthShort: "OCT",
    start: { month: "10", day: "01" },
    end: { month: "10", day: "31" },
    asInt: "10",
  },
  {
    monthLong: "November",
    monthShort: "NOV",
    start: { month: "11", day: "01" },
    end: { month: "12", day: "01" },
    asInt: "11",
  },
  {
    monthLong: "December",
    monthShort: "DEC",
    start: { month: "12", day: "02" },
    end: { month: "12", day: "31" },
    asInt: "12",
  },
];
